import { HelpService } from '@appStore/help/services/help.service';
import { GuidesService } from '@appStore/help/services/guides.service';
import { UserGuidesService } from '@appStore/help/services/user-guides.service';

export const services: any[] = [HelpService, GuidesService, UserGuidesService];

export * from '@appStore/help/services/help.service';
export * from '@appStore/help/services/guides.service';
export * from '@appStore/help/services/user-guides.service';
